import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { buildGatewayUrl } from '../../state/ipfs';

const getCidFromSearch = (search) => {
  const params = new URLSearchParams(search);
  return params.get('cid');
};

const IpfsImagePreview = () => {
  const { search } = useLocation();
  const [src, setSrc] = useState('');
  const [error, setError] = useState('');
  const cid = getCidFromSearch(search);

  useEffect(() => {
    const loadImage = async () => {
      if (!cid) {
        setError('CID is missing.');
        return;
      }

      try {
        const response = await fetch(buildGatewayUrl(cid));
        if (!response.ok) {
          setError('Failed to load image data.');
          return;
        }

        const contentType = response.headers.get('content-type') || '';
        if (contentType.startsWith('image/')) {
          const blob = await response.blob();
          setSrc(URL.createObjectURL(blob));
          return;
        }

        const text = await response.text();
        if (text.startsWith('data:')) {
          setSrc(text);
          return;
        }

        let data = null;
        try {
          data = JSON.parse(text);
          if (typeof data === 'string') {
            data = JSON.parse(data);
          }
        } catch (e) {
          setError('Invalid image data.');
          return;
        }

        if (!data?.data) {
          setError('Invalid image data.');
          return;
        }

        const base64Photo = data.data.includes('data:') ? data.data : `data:${data.mime || 'image/jpeg'};base64,${data.data}`;
        setSrc(base64Photo);
      } catch (e) {
        setError('Failed to load image data.');
      }
    };

    loadImage();
  }, [cid]);

  if (error) {
    return (
      <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        {error}
      </div>
    );
  }

  if (!src) {
    return (
      <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        Loading...
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
      <img src={src} alt="preview" style={{ maxWidth: '100%', height: 'auto' }} />
    </div>
  );
};

export default IpfsImagePreview;
